import React, { useState } from 'react'
import { AnswerAnalyses } from "@components/teachV2/FreeTextQuestion/ResultTextQuestion";
import { useLocation } from 'react-router-dom'
import TabQuestionInformation from './TabQuestionInformation'

export default function FreeTextDetail(props) {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location?.state?.analysis ? 2 : 1);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const tabsOption = [
    { id: 1, key: "question", label: "Question Information" },
    { id: 2, key: "answer", label: "Answer Analyses" },
  ] 

  return (
    <div className="result-wrap">
      <div className='reference-wrap__tabs'>
        {tabsOption?.map((tab, index) => (
          <div 
            key={index}
            className={`tab-detail ${tab.id === activeTab ? "tab-active" : ""}`} 
            onClick={() => handleTabChange(tab.id)}
          >
            <p>{tab?.label}</p>
          </div>
        ))}
      </div>
      <div>
        {activeTab === 1 && ( 
          <TabQuestionInformation {...props}/>
        )}
        {activeTab === 2 && (
          <AnswerAnalyses
            {...props}
          />
        )}
      </div>
    </div>
  )
}
